const REQUEST_ERROR_EVENTS = {
  RATE_LIMIT_EXCEEDED_ERROR: 'RATE_LIMIT_EXCEEDED_ERROR',
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR'
};

export {REQUEST_ERROR_EVENTS};
